import { useMaterialUIController } from "context";

const STATUS = {
  healthy:        "#66bb6a",
  warning:        "#ffa726",
  critical:       "#f44336",
  unknown:        "#9e9e9e",
  office:         "#42a5f5",
  decommissioned: "#7e57c2",
};

export const ICCC_COLORS_DARK = {
  ...STATUS,

  healthyBg:  "rgba(102,187,106,0.12)",
  warningBg:  "rgba(255,167,38,0.12)",
  criticalBg: "rgba(244,67,54,0.14)",
  unknownBg:  "rgba(255,255,255,0.04)",

  pageBg:      "#121212",
  cardBg:      "#1e1e1e",
  cardBg2:     "#2a2a2a",
  cardBorder:  "rgba(255,255,255,0.08)",
  divider:     "rgba(255,255,255,0.10)",
  hoverBg:     "rgba(255,255,255,0.04)",
  shadow:      "0 1px 3px rgba(0,0,0,0.6), 0 1px 2px rgba(0,0,0,0.4)",

  textPrimary:   "#ffffff",
  textSecondary: "rgba(255,255,255,0.72)",
  textMuted:     "rgba(255,255,255,0.50)",
  textDim:       "rgba(255,255,255,0.38)",

  accent:        "#90caf9",
};

export const ICCC_COLORS_LIGHT = {
  ...STATUS,

  healthyBg:  "rgba(102,187,106,0.14)",
  warningBg:  "rgba(255,167,38,0.16)",
  criticalBg: "rgba(244,67,54,0.14)",
  unknownBg:  "rgba(0,0,0,0.04)",

  pageBg:      "#eef1f6",
  cardBg:      "#ffffff",
  cardBg2:     "#f7f9fc",
  cardBorder:  "rgba(0,0,0,0.18)",
  divider:     "rgba(0,0,0,0.14)",
  hoverBg:     "rgba(25,118,210,0.06)",
  shadow:      "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)",

  textPrimary:   "#1a1f36",
  textSecondary: "rgba(26,31,54,0.78)",
  textMuted:     "rgba(26,31,54,0.62)",
  textDim:       "rgba(26,31,54,0.45)",

  accent:        "#1976d2",
};

export const ICCC_COLORS = ICCC_COLORS_DARK;

export function useICCCColors() {
  const [controller] = useMaterialUIController();
  return controller?.darkMode ? ICCC_COLORS_DARK : ICCC_COLORS_LIGHT;
}

export const STATUS_FOR_PIE = [
  { key: "healthy",  label: "Healthy",  color: STATUS.healthy },
  { key: "warning",  label: "Warning",  color: STATUS.warning },
  { key: "critical", label: "Critical", color: STATUS.critical },
  { key: "unknown",  label: "Unknown",  color: STATUS.unknown },
];
